import { drawImage, getContext } from './images.js'
import { randomIntRange, randomJitter, GetPlayer } from './game.js'
import { playSfx } from './sfx.js'
import { playTrack, stopTrack } from './music.js'
import upgrades from './upgrades.json'
import Particle from './particle.js'

var player = GetPlayer()
var fnOnComplete = () => {}
var elapsed = 0
var cards = []
var selection = 0
var cardSpeed = 0.6
var cardLeft = 22 
var state = 'transition-in'
var bar1x = -200
var bar2x = 200
var barSpeed = 0.8
var ctx = null
var paused = true
var interval = null

var particles = []

function addParticle(image, x, y, velocityX, velocityY, composition, onDestroy, onUpdate) {
    let particle = new Particle(image, x, y, velocityX, velocityY, composition, (p) => {
        if (onDestroy) {
            onDestroy(p)
        }
        removeParticle(p)
    }, onUpdate)
    particle.destroyNonMoving = true
    particle.h = 8
    particle.w = 8
    particle.minVecY = 0.003
    particle.friction = 0.01
    particles.push(particle)
    return particle
}

function removeParticle(particle) {
    let partIndex = particles.findIndex(f => f === particle)
    if (partIndex >= 0) {
        particles[partIndex] = undefined
    }
    return particle
}

function HandleInput(input, amt) {
    if (input === 'up') {
        selection -= amt
    } else if (input === 'down') {
        selection += amt
    } else if (input === 'attack') {
        state = 'transition-out'
    }

    selection = selection < 0 ? cards.length - 1 : selection
    selection = selection >= cards.length ? 0 : selection
}

function addCard(title, description) {
    cards.push({
        title: title,
        description: description,
        x: 200 //* (cards.length + 1)
    })
}

function Start(onComplete) {
    ctx = getContext()
    particles = []
    bar1x = -200
    bar2x = 200
    elapsed = 0
    cards = []
    selection = 0
    state = 'transition-in'
    paused = false
    playTrack('levelup')
    if (onComplete) {
        fnOnComplete = onComplete
    } else {
        fnOnComplete = () => {}
    }

    player = GetPlayer()
    for (let i = 0; i < 3; i++) {
        let ulist = upgrades.filter(f => cards.filter(c => c.title === f.name).length === 0
            && f.levels[0] <= player.level + 1 && f.levels[1] >= player.level + 1)
        console.log('player level', ulist, player.level)
        if (ulist.length > 0) {
            let index = randomIntRange(0, ulist.length - 1)
            let upgrade = ulist[index]
            addCard(upgrade.name, upgrade.description)
        }
    }

    interval = setInterval(() => {
        spawnParticles(randomJitter(24, 48))
    }, 200)
}

function spawnParticles(n) {
    for (let i = 0; i < n; i++) {
        let x = 100 + randomJitter(-104, 104)
        addParticle('xp-gem', x, randomJitter(-12, -2), randomJitter(-0.01, 0.01), randomJitter(0.095, 0.105), 'source-over')
        // let p1 = addParticle('Spark-Particle', parseInt(titlex), 24, -xspeed + randomJitter(-0.06, 0.06), 0.1 + randomJitter(-0.06, 0.06), 'lighten')
        // p1.x += randomJitter(-4, 4)
        // p1.y += randomJitter(-4, 4)
        // let p2 = addParticle('Spark-Particle', parseInt(titlex + width + 4), 24, xspeed + randomJitter(-0.06, 0.06), 0.1 + randomJitter(-0.06, 0.06), 'lighten')
        // p2.x += randomJitter(-4, 4)
        // p2.y += randomJitter(-4, 4)

        // let p3 = addParticle('Spark-Particle', parseInt(titlex), 24, -xspeed + randomJitter(-0.06, 0.06), -0.1 + randomJitter(-0.06, 0.06), 'lighten')
        // p3.x += randomJitter(-4, 4)
        // p3.y += randomJitter(-4, 4)
        // let p4 = addParticle('Spark-Particle', parseInt(titlex + width + 4), 24, xspeed + randomJitter(-0.06, 0.06), -0.1 + randomJitter(-0.06, 0.06), 'lighten')
        // p4.x += randomJitter(-4, 4)
        // p4.y += randomJitter(-4, 4)

        // let p5 = addParticle('Spark-Particle', parseInt(titlex), 24, -xspeed + randomJitter(-0.06, 0.06), randomJitter(-0.05, 0.05), 'lighten')
        // p5.x += randomJitter(-4, 4)
        // p5.y += randomJitter(-4, 4)
        // let p6 = addParticle('Spark-Particle', parseInt(titlex + width + 4), 24, xspeed + randomJitter(-0.06, 0.06), randomJitter(-0.05, 0.05), 'lighten')
        // p6.x += randomJitter(-4, 4)
        // p6.y += randomJitter(-4, 4)
    }
}

function AnimationFrame(delta) {
    elapsed += delta
    // Get rid of any destroyed (IE: undefined) particles.
    particles = particles.filter(f => f)

    if (state === 'transition-in') {
        bar1x += barSpeed * delta
        bar2x -= barSpeed * delta
        
        if (bar1x > 0) {
            bar1x = bar1x > 0 ? 0 : bar1x
            bar2x = bar2x < 0 ? 0 : bar2x
            playSfx('levelup')
            state = 'select-upgrade'
        }
    }

    let ga = ctx.globalAlpha
    ctx.globalAlpha = 0.6
    ctx.fillStyle = '#000000'
    let midpoint = parseInt(187 / 2)
    ctx.fillRect(parseInt(bar1x), 0, 200, midpoint)
    ctx.fillRect(parseInt(bar2x), midpoint, 200, midpoint + 1)
    ctx.globalAlpha = ga

    particles.forEach(p => {
        if (p) {
            p.Update(delta)
            p.opacity = 1 - p.y / 190
            p.Draw()
        }
    })

    let title = 'LEVEL UP!'
    let titlex = 100 - parseInt(bfontjs.CalculateTextWidth(title, bfontjs.Fonts('default')) / 2)
    bfontjs.DrawText(ctx, titlex, 20, title, '#090909d9')
    bfontjs.DrawText(ctx, titlex, 19, title, '#f1f100ff', undefined, { gradient: { colour: '#a94909ff' } })

    cards.forEach((card, index) => {
        if (state === 'transition-in') {            
            if (elapsed >= 300 && elapsed <= 5000) {
                card.x -= delta * cardSpeed
                if (card.x < cardLeft) {
                    card.x = cardLeft
                }
            }
        } else if (state === 'transition-out') {
            card.x += delta * cardSpeed
            if (card.x > 200) {
                bar1x -= barSpeed * delta
                bar2x += barSpeed * delta
            
                if (bar1x < -200) {
                    stopTrack('levelup')
                    fnOnComplete(upgrades.filter(f => f.name === cards[selection].title)[0])
                    paused = true
                    fnOnComplete = () => {}
                }
            }
        } else {
            card.x = cardLeft
        }

        let cy = 40 + index * 48
        drawImage('ui-xpcard', card.x, cy)

        if (selection === index && elapsed % 500 < 250) {
            drawImage('select-arrow', card.x - 2, cy + 16)
        }
        bfontjs.DrawText(ctx, card.x + 3, cy + 3, card.title, '#090909d9')
        bfontjs.DrawText(ctx, card.x + 3, cy + 2, card.title, '#f1f100ff', undefined, { gradient: { colour: '#a94909ff' } })

        bfontjs.DrawText(ctx, card.x + 24, cy + 20, card.description, '#090909d9', eighties)
        bfontjs.DrawText(ctx, card.x + 24, cy + 19, card.description, '#f1f1f1ff', eighties)
    })
}

export { AnimationFrame, Start, HandleInput }